import { createApp } from "vue";
import { createI18n } from "vue-i18n";
import en from "~/locales/en/index.js";
import ja from "~/locales/ja/index.js";
import pt from "~/locales/pt/index.js";
import fr from "~/locales/fr/index.js";
import es from "~/locales/es/index.js";
// import installI18n, { i18n } from '@/i18n/basic/index';

import LoginDialog from "~/components/account/LoginDialog.vue";
import ResetPassWordDialog from "~/components/account/ResetPassWordDialog.vue";
// import SignUpDialog from './SignUpDialog.vue';
import SignUpDialog from "~/components/account/SignUpDialog.vue";
// import SelectStyleDialog from './SelectStyleDialog.vue';
// import InfoDialogPlugin from './common/dialog/infoDialog';

// import ToastPlugin from "~/components/toast/toast";
// import LooksLikeGuideDialog from './LooksLikeGuideDialog.vue';
import { AnalyticHub } from '~/utils/analytic';

/**
 *
 * @param {*} param0
 * element: vue组件
 * props 传参
 */
function dialog({ element, props }) {
  const i18n = createI18n({
    legacy: false, // Use Composition API mode
    locale: ENV.currentConfig.lang,
    messages: {
      en,
      ja,
      fr,
      es,
      pt
    },
  });
  const close = props.close;
  const id = Math.random().toString(36) + Date.now();
  let ToastConstructor = {};
  props.close = () => {
    close?.();
    ToastConstructor.unmount();
    document.getElementById(id)?.remove();
  };
  ToastConstructor = createApp(element, props);
  const container = document.createElement("div");
  container.id = id;
  document.body.appendChild(container);
  ToastConstructor.use(i18n);
  // ToastConstructor.use(InfoDialogPlugin);
  //   ToastConstructor.use(ToastPlugin);
  //   ToastConstructor.config.globalProperties.$utility = CommonUtility;
  //   ToastConstructor.config.globalProperties.i18n = i18n;
  // ToastConstructor.config.globalProperties.$analytic = AnalyticHub.getInstance;
  //   CommonUtility.init();
  ToastConstructor.mount(container);
}

/** 登录页弹窗 转为方法使用 */
function loginDialog() {
  dialog({ element: LoginDialog, props: {} });
}

/** 重置密码弹窗 */
function resetPassWordDialog() {
  dialog({ element: ResetPassWordDialog, props: {} });
}

/** 注册弹窗 */
function signUpDialog() {
  dialog({ element: SignUpDialog, props: {} });
}
/** 选择风格 */
function selectStyleDialog() {
  // dialog({ element: SelectStyleDialog, props: {} });
}
function guideDialog() {
  // dialog({ element: LooksLikeGuideDialog, props: {} });
}

/** 产品需求 页面弹窗能够互相返回上一级  初步是三个类型 */
let pageNextList = [];
const pageDialog = {
  loginDialog,
  resetPassWordDialog,
  signUpDialog,
};
/** 清空页面栈 */
const clearPageNextList = () => {
  pageNextList = [];
};

const permissionDialog = () => {
  if (!isLogined()) {
    loginDialog()
  }
}



export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      signUpDialog,
      loginDialog,
      resetPassWordDialog,
      pageNextList,
      clearPageNextList,
      pageDialog,
      analytic: AnalyticHub.getInstance,
      permissionDialog
    },
  };
});
